import { render, staticRenderFns } from "./ObiTabBar.vue?vue&type=template&id=56e945e2&scoped=true&"
import script from "./ObiTabBar.vue?vue&type=script&lang=js&"
export * from "./ObiTabBar.vue?vue&type=script&lang=js&"
import style0 from "./ObiTabBar.vue?vue&type=style&index=0&id=56e945e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e945e2",
  null
  
)

export default component.exports